import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import CommonButton from "../../../../component/Button";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import EditIndex from "../../common-card.js/Edit-Index";

export default function ReviewInfo({
  handleClose,
  reviewInfo,
  jobValue,
  anomalyData,
  handleKeepAsDraft,
  handleIgnoreToggle,
  validInsights,
  handleAnomalyCheck,
  menuItemData,
  disabledButton,
  fieldLevelData,
  filterInferredSkill,
  filterFieldLevelData,
  filterMandatoryData,
  values,
  handleFieldLevelIgnoreToggle,
}) {
  const [submitType, setSubmitType] = useState(null);

  const initialValues = {
    job_title: values.job_title || "",
    company_name: values.company_name || "",
    location: values.location || "",
    bu_department_team: values.bu_department_team || "",
    education: values.education || "",
    available_education: values.available_education || [],
    visa_status: values.visa_status || [],
    available_visa_status: values.available_visa_status || [],
    specific_degree: values.specific_degree || "",
    location_targets: values.location_targets || [],
    location_targets_value: "",
    industry: values.industry || [],
    available_industry: values.available_industry || [],
    management_level: values.management_level || "",
    available_management_level: values.available_management_level || [],
    employment: values.employment || "",
    available_employment_types: values.available_employment_types || [],
    start_date: values.start_date || null,
    end_date: values.end_date || null,
    occupational_classification: values.occupational_classification || "",
    available_occupational_classification:
      values.available_occupational_classification || [],
    company_profile: values.company_profile || "",
    available_company_profiles: values.available_company_profiles || [],
    is_inference_reviewed: values.is_inference_reviewed,
    pay_rate: {
      max: values?.pay_rate?.max,
      min: values?.pay_rate?.min,
      currency: values?.pay_rate?.currency || "USD",
    },
  };

  const validationSchema = Yup.object().shape({
    job_title: Yup.string().required("Job title is required"),
    company_name: Yup.string().required("Company name is required"),
    // ...(filterInferredSkill.length !== 0
    //   ? {
    //       is_inference_reviewed: Yup.boolean().oneOf(
    //         [true],
    //         "Please verify the inferred data"
    //       ),
    //     }
    //   : {}),
    pay_rate: Yup.object().shape({
      min: Yup.number()
        .typeError("Minimum pay rate must be a number")
        .min(0, "Minimum pay rate cannot be negative")
        .nullable(),
      max: Yup.number()
        .typeError("Maximum pay rate must be a number")
        .nullable()
        .when("min", (min, schema) =>
          min !== undefined && min !== null
            ? schema.moreThan(
                min,
                "Maximum pay rate must be greater than the minimum"
              )
            : schema
        ),
    }),
    start_date: Yup.string()
  .nullable()
  .test(
    "start-before-end",
    "Start date cannot be after end date",
    function (value) {
      const { end_date } = this.parent;

      if (!value || !end_date) return true;

      const s = dayjs(value, "DD MMM YYYY");
      const e = dayjs(end_date, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !s.isAfter(e, "day");
    }
  )
  .test(
    "start-not-same",
    "Start date and end date cannot be the same",
    function (value) {
      const { end_date } = this.parent;

      if (!value || !end_date) return true;

      const s = dayjs(value, "DD MMM YYYY");
      const e = dayjs(end_date, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !s.isSame(e, "day");
    }
  ),

end_date: Yup.string()
  .nullable()
  .test(
    "end-after-start",
    "End date cannot be before start date",
    function (value) {
      const { start_date } = this.parent;

      if (!value || !start_date) return true;

      const s = dayjs(start_date, "DD MMM YYYY");
      const e = dayjs(value, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !e.isBefore(s, "day");
    }
  )
  .test(
    "end-not-same",
    "Start date and end date cannot be the same",
    function (value) {
      const { start_date } = this.parent;

      if (!value || !start_date) return true;

      const s = dayjs(start_date, "DD MMM YYYY");
      const e = dayjs(value, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !e.isSame(s, "day");
    }
  ),});

  const initializedPopup = useRef(false);
  useEffect(() => {
    initializedPopup.current = true;
  }, [reviewInfo.open]);
  return (
    <Dialog
      open={reviewInfo.open}
      fullWidth
      maxWidth={"md"}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Typography variant="body5" marginLeft={"1rem"}>
          Review Information
        </Typography>
        <Button onClick={handleClose}>
          <CloseIcon />
        </Button>
      </DialogActions>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={() => {
          if (submitType === "draft") {
            handleKeepAsDraft({ condition: false });
          }
          if (submitType === "rescore") {
            handleKeepAsDraft({ condition: true });
          }
        }}
      >
        {({ values, errors, touched }) => {
          console.log(errors, "errors-formik");
          return (
            <Form
              onClick={() => {
                const errorElement = document.querySelector(".Mui-error");
                if (errorElement) {
                  errorElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }
              }}
            >
              <CustomDiv padding="10px 1.5rem 1rem">
                <CommonGrid2
                  container
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"2rem"}
                >
                  {filterMandatoryData.mandatoryDisabled && reviewInfo.open && (
                    <CommonGrid2 item size={12}>
                      <Typography variant="h5" marginBottom={"15px"}>
                        Missing Mandatory Fields
                      </Typography>
                      <EditIndex
                        editData={filterMandatoryData.mandatoryData}
                        initializedPopup={initializedPopup}
                      />
                    </CommonGrid2>
                  )}
                  {filterInferredSkill.length !== 0 && (
                    <CommonGrid2 item size={12}>
                      <Typography variant="h5" marginBottom={"15px"}>
                        Verify the Inferred Fields
                      </Typography>
                      <EditIndex
                        editData={filterInferredSkill}
                        initializedPopup={initializedPopup}
                      />
                      <FormControlLabel
                        sx={{
                          marginTop: "10px",
                          // color:
                          //   touched.is_inference_reviewed &&
                          //   errors.is_inference_reviewed &&
                          //   "#d32f2f",
                        }}
                        control={
                          <Checkbox
                            checked={values.is_inference_reviewed}
                            onChange={(e) => handleAnomalyCheck(e)}
                          />
                        }
                        label="I have verified the inferred data provided by the AI."
                      />
                      {/* {touched.is_inference_reviewed &&
                        errors.is_inference_reviewed && (
                          <Typography
                            className="Mui-error"
                            color="error"
                            fontSize="11px"
                            fontWeight={600}
                          >
                            {errors.is_inference_reviewed}
                          </Typography>
                        )} */}
                    </CommonGrid2>
                  )}

                  {validInsights?.length !== 0 && (
                    <CommonGrid2 item>
                      <Typography variant="h5" marginBottom={"10px"}>
                        Anomalies
                      </Typography>

                      <CommonGrid2
                        display={"flex"}
                        flexDirection={"column"}
                        gap={"10px"}
                      >
                        {jobValue?.insights?.insights?.map((item, index) => {
                          if (item.fix || !item?.fields?.length) return null;
                          // const hasDateRange =
                          //   item?.fields?.includes("start_date") &&
                          //   item?.fields?.includes("end_date");
                          const data = anomalyData.filter((anomaly) => {
                            if (item?.fields?.includes(anomaly.titleName)) {
                              return true;
                            }
                            // if (
                            //   hasDateRange &&
                            //   anomaly.titleName === "Date_Range"
                            // ) {
                            //   return true;
                            // }

                            return false;
                          });

                          return (
                            <CommonGrid2
                              key={index}
                              container
                              borderRadius={"10px"}
                              padding={"10px"}
                              background="#F7F8F9"
                              gap={"10px"}
                            >
                              <CommonGrid2
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                                width={"99%"}
                              >
                                <CommonGrid2
                                  display={"flex"}
                                  alignItems={"start"}
                                  justifyContent={"start"}
                                  gap={"10px"}
                                  width={"100%"}
                                >
                                  <CommonGrid2
                                    display={"flex"}
                                    minWidth={"auto"}
                                  >
                                    <ExclamatoryIco />
                                  </CommonGrid2>

                                  <CommonGrid2
                                    display={"flex"}
                                    flexDirection={"column"}
                                    width={"100%"}
                                  >
                                    <CommonGrid2
                                      display={"flex"}
                                      width={"100%"}
                                      justifyContent={"space-between"}
                                      gap={"1rem"}
                                    >
                                      <Typography
                                        variant="body4"
                                        color="#00144A"
                                        width={"fit-content"}
                                      >
                                        {item.content}
                                      </Typography>
                                      <CommonGrid2
                                        display={"flex"}
                                        alignItems={"center"}
                                        gap={"10px"}
                                      >
                                        <Typography
                                          variant="body4"
                                          color="#00144A"
                                        >
                                          {"Ignore"}
                                        </Typography>
                                        <Switch
                                          checked={item.is_ignored}
                                          onChange={() =>
                                            handleIgnoreToggle(index)
                                          }
                                        />
                                      </CommonGrid2>
                                    </CommonGrid2>
                                    <CommonGrid2
                                      item
                                      size={12}
                                      marginTop={"1rem"}
                                      paddingRight={"1rem"}
                                    >
                                      <EditIndex
                                        editData={data}
                                        menuItemData={menuItemData}
                                        initializedPopup={initializedPopup}
                                      />
                                    </CommonGrid2>
                                  </CommonGrid2>
                                </CommonGrid2>
                              </CommonGrid2>
                            </CommonGrid2>
                          );
                        })}
                      </CommonGrid2>
                    </CommonGrid2>
                  )}

                  {filterFieldLevelData?.length !== 0 && (
                    <CommonGrid2 item size={12}>
                      <Typography variant="h5" marginBottom={"15px"}>
                        Field Level Anomaly
                      </Typography>

                      <CommonGrid2
                        display={"flex"}
                        flexDirection={"column"}
                        gap={"10px"}
                      >
                        {filterFieldLevelData?.map((item, index) => {
                          const data = fieldLevelData.filter(
                            (anomaly) => anomaly.titleName === item.titleName
                          );

                          console.log(
                            jobValue?.[item.anomalyFieldName],
                            "sfsjfsjkfjsfjk"
                          );

                          return (
                            <CommonGrid2
                              key={index}
                              container
                              borderRadius={"10px"}
                              padding={"10px"}
                              background="#F7F8F9"
                              gap={"10px"}
                            >
                              <CommonGrid2
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                                width={"99%"}
                              >
                                <CommonGrid2
                                  display={"flex"}
                                  alignItems={"start"}
                                  justifyContent={"start"}
                                  gap={"10px"}
                                  width={"100%"}
                                >
                                  <CommonGrid2
                                    display={"flex"}
                                    minWidth={"auto"}
                                  >
                                    <ExclamatoryIco />
                                  </CommonGrid2>

                                  <CommonGrid2
                                    display={"flex"}
                                    flexDirection={"column"}
                                    width={"100%"}
                                  >
                                    <Typography
                                      variant="body4"
                                      color="#00144A"
                                      width={"fit-content"}
                                    >
                                      {item.anomaly}
                                    </Typography>
                                    <CommonGrid2
                                      item
                                      size={12}
                                      marginTop={"1rem"}
                                      paddingRight={"1rem"}
                                    >
                                      <EditIndex
                                        editData={data}
                                        menuItemData={menuItemData}
                                        initializedPopup={initializedPopup}
                                      />
                                    </CommonGrid2>
                                  </CommonGrid2>
                                </CommonGrid2>
                                <CommonGrid2
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={"10px"}
                                >
                                  <Typography variant="body4" color="#00144A">
                                    {"Ignore"}
                                  </Typography>
                                  <Switch
                                    checked={
                                      jobValue?.[item.anomalyFieldName]?.[
                                        "is_ignored"
                                      ]
                                    }
                                    onChange={() =>
                                      handleFieldLevelIgnoreToggle(item)
                                    }
                                  />
                                </CommonGrid2>
                              </CommonGrid2>
                            </CommonGrid2>
                          );
                        })}
                      </CommonGrid2>
                    </CommonGrid2>
                  )}
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"end"}
                    gap={"1rem"}
                    flexWrap={"wrap"}
                  >
                    <CommonButton
                      variant="outlined"
                      value={"Cancel"}
                      fontWeight={"600"}
                      onClick={handleClose}
                      padding={"8px 28px"}
                      disabled={reviewInfo.disabled}
                    />
                    <CommonButton
                      variant="outlined"
                      value={"Save"}
                      fontWeight={"600"}
                      type="submit"
                      onClick={() => setSubmitType("draft")}
                      padding={"8px 28px"}
                      disabled={reviewInfo.disabled || disabledButton}
                      loading={reviewInfo.draftLoading}
                    />
                    <CommonButton
                      value={"Save and Rescore"}
                      fontWeight={"600"}
                      onClick={() => setSubmitType("rescore")}
                      type="submit"
                      padding={"8px 28px"}
                      disabled={reviewInfo.disabled || disabledButton}
                      loading={reviewInfo.rescoreLoading}
                    />
                  </CommonGrid2>
                </CommonGrid2>
              </CustomDiv>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
